export const ArcadeEmbed = () => {
  return (
    <div
      style={{
        position: 'relative',
        paddingBottom: 'calc(49.895833333333336% + 41px)',
        height: '0',
        width: '100%'
      }}
    >
      <iframe
        allowFullScreen
        allow='clipboard-write'
        loading='lazy'
        src='https://demo.arcade.software/cItDG3iDliMcQavzoSuA?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true'
        title='Updated Exporting | GX Go'
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          colorScheme: 'light',
          border: 'none'
        }}
      />
    </div>
  );
};
